import { createTrackingUtils } from "../index";

const utils = createTrackingUtils({
  name: "flights_apex_web_filter_on_flexible_ticket",
  stages: {
    affected_users: 1,
    main: 2,
    mdot: 3,
    ddot: 4,
    flex_enabled: 5,
    multiple_filters: 6,
    zero_results: 7
  },
  goals: {
    enable_flex: 1,
    disable_flex: 2
  },
  goalsWithValue: ["enable_flex_filter_count"],
  defaultStage: 1
});

const trackStages = (isMobile: boolean, isEnabled: boolean, filtersSelected: number, filteredTotalCount?: number) => {
  utils.stages.main();
  if (isMobile) utils.stages.mdot();
  if (!isMobile) utils.stages.ddot();
  if (filtersSelected > 1) utils.stages.multiple_filters();
  if (isEnabled) utils.stages.flex_enabled();
  if (isEnabled && filteredTotalCount === 0) utils.stages.flex_enabled();
};

export default { ...utils, trackStages };
